export const NEW_USER = (id) => `settings/all-users/edit?id=${id ?? ''}`
export const NEW_ACCOUNT = (id) => `accounts/edit?id=${id ?? ''}`
export const NEW_NETWORK = (id) => `networks/edit?id=${id ?? ''}`
export const DEAL_BRIEFING = (id) => `contextual/deal_briefing/${id ?? ''}`